import React, { Component, Fragment } from "react";
import Grid from "react-bootstrap/lib/Grid";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";
import MainContainer from "pages/_components/MainContainer";
import Head from "pages/_components/Head";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import * as i18n from "util/i18n";
import { func, shape } from "prop-types";

class PrivacyPolicy extends Component {
    static propTypes = {
        history: shape({ goBack: func }),
    };

    static defaultProps = {
        history: null,
    };

    backButtonAction = () => {
        const { history } = this.props;
        history.goBack();
    };

    render() {
        return (
            <Fragment>
                <Head title="global.privacy.web" onClose={this.backButtonAction} />

                <MainContainer>
                    <div className="above-the-fold">
                        <section className="container--layout flex-grow">
                            <Grid fluid>
                                <Row className="justify-content-center">
                                    <Col className="col-12">
                                        <div className="scrollable-content">
                                            <div className="text-left">
                                                <Image src="images/logoCompany.svg" className="svg-image" />
                                            </div>
                                            <div
                                                className="text-left"
                                                style={{ width: "200px", position: "absolute", right: 0 }}>
                                                <I18n id="privacyPolicy.header.text" />
                                            </div>

                                            <br />
                                            <br />
                                            <div className="text-center" style={{ paddingTop: "50px" }}>
                                                <h3>{i18n.get("privacyPolicy.title")}</h3>
                                            </div>

                                            <br />
                                            <I18n id="privacyPolicy.paragraph1" />
                                            <br />
                                            <br />
                                            <I18n id="privacyPolicy.paragraph2" />
                                            <br />
                                            <br />

                                            <div className="font-bold">
                                                <h3>{i18n.get("privacyPolicy.subtitle1")}</h3>
                                            </div>
                                            <br />

                                            <I18n id="privacyPolicy.paragraph3" />
                                            <br />
                                            <br />

                                            <div className="font-bold">
                                                <h3>{i18n.get("privacyPolicy.subtitle2")}</h3>
                                            </div>
                                            <br />

                                            <I18n id="privacyPolicy.paragraph4" />
                                            <br />
                                            <br />
                                            <div className="font-bold">
                                                <h4>{i18n.get("privacyPolicy.subtitle3")}</h4>
                                            </div>
                                            <br />

                                            <I18n id="privacyPolicy.paragraph5" />
                                            <br />
                                            <br />

                                            <div className="font-bold">
                                                <h4>{i18n.get("privacyPolicy.subtitle4")}</h4>
                                            </div>
                                            <br />

                                            <I18n id="privacyPolicy.paragraph6" />
                                            <br />
                                            <br />

                                            <div className="font-bold">
                                                <h4>{i18n.get("privacyPolicy.subtitle5")}</h4>
                                            </div>
                                            <br />

                                            <I18n id="privacyPolicy.paragraph7" />
                                            <br />
                                            <br />

                                            <div className="font-bold">
                                                <h4>{i18n.get("privacyPolicy.subtitle6")}</h4>
                                            </div>
                                            <br />

                                            <I18n id="privacyPolicy.paragraph8" />
                                        </div>
                                    </Col>
                                </Row>
                            </Grid>
                        </section>
                    </div>
                </MainContainer>
            </Fragment>
        );
    }
}

export default PrivacyPolicy;
